import { isGdprCountry } from '@change-corgi/config/countries';

import { useCountryCode } from '#src/app/shared/hooks/l10n';

export function useGdprEnabled(): boolean {
	const countryCode = useCountryCode();

	return isGdprCountry(countryCode);
}
